import Vue from 'vue'
import Router from 'vue-router'
import constantes from './services/Constantes'
import NProgress from 'nprogress'
import VueJwtDecode from 'vue-jwt-decode'
import axios from 'axios'
import ApiService from './services/ApiService'

Vue.use(Router)

const apiService = new ApiService(axios, VueJwtDecode)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'inicio',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "inicio" */ './views/Inicio.vue')
    },
    {
      path: '/sucursal',
      name: 'sucursal',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "sucursal" */ './views/Sucursal.vue')
    },
    {
      path: '/nosotros',
      name: 'nosotros',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "nosotros" */ './views/Nosotros.vue')
    },
    {
      path: '/contacto',
      name: 'contacto',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "contacto" */ './views/Contacto.vue')
    },
    {
      path: '/subir-fotos',
      name: 'subir-fotos',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "subir-fotos" */ './views/Pedidos/SubirFotosGeneral.vue')
    },
    {
      path: '/subir-fotos/oferta/:id',
      name: 'subir-fotos-oferta',
      meta: {
        grupo: constantes.gruposRutas.USUARIO
      },
      component: () => import(/* webpackChunkName: "subir-fotos" */ './views/Pedidos/SubirFotos.vue')
    },
    {
      path: '/subir-fotos/pack/:id',
      name: 'subir-fotos-pack',
      meta: {
        grupo: constantes.gruposRutas.USUARIO
      },
      component: () => import(/* webpackChunkName: "subir-fotos" */ './views/Pedidos/SubirFotos.vue')
    },
    {
      path: '/pedido/:id/',
      name: 'pedido-estado',
      meta: {
        grupo: constantes.gruposRutas.USUARIO
      },
      component: () => import(/* webpackChunkName: "pedido-estado" */ './views/Pedidos/Estado.vue')
    },
    {
      path: '/politica-de-privacidad',
      name: 'politica-privacidad',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "politica-privacidad" */ './views/PoliticaPrivacidad.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "login" */ './views/Auth/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "register" */ './views/Auth/Register.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "forgot-password" */ './views/Auth/ForgotPassword.vue')
    },
    {
      path: '/change-password',
      name: 'change-password',
      meta: {
        grupo: constantes.gruposRutas.USUARIO
      },
      component: () => import(/* webpackChunkName: "change-password" */ './views/Auth/ChangePassword.vue')
    },
    {
      path: '/admin/pedidos',
      name: 'admin-pedidos',
      meta: {
        grupo: constantes.gruposRutas.ADMIN
      },
      component: () => import(/* webpackChunkName: "admin-pedidos" */ './views/Admin/Pedidos.vue')
    },
    {
      path: '/usuario/pedidos',
      name: 'usuario-pedidos',
      meta: {
        grupo: constantes.gruposRutas.USUARIO
      },
      component: () => import(/* webpackChunkName: "usuario-pedidos" */ './views/Usuario/Pedidos.vue')
    },
    {
      path: '/sesion-expirada',
      name: 'sesion-expirada',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "error404" */ './views/SesionExpirada.vue')
    },
    {
      path: '/usuario/perfil',
      name: 'perfil',
      meta: {
        grupo: constantes.gruposRutas.USUARIO
      },
      component: () => import(/* webpackChunkName: "error404" */ './views/Usuario/Perfil.vue')
    },
    {
      path: '/confimar-usuario/:token',
      name: 'confimar-usuario',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "confimar-usuario" */ './views/Auth/ConfirmUser.vue')
    },
    {
      path: '/resetear-contrasena/:token',
      name: 'resetear-contrasena',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "resetear-contrasena" */ './views/Auth/ResetPassword.vue')
    },
    {
      path: '/webmail',
      name: 'webmail',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "webmail" */ './views/Webmail.vue')
    },
    {
      path: '*',
      name: 'error404',
      meta: {
        grupo: constantes.gruposRutas.PUBLICAS
      },
      component: () => import(/* webpackChunkName: "error404" */ './views/Error404.vue')
    }
  ],
  // En cada ruta nueva que se genera, lleva al usuario al top de dicha ruta
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeResolve((to, from, next) => {
  // Inicia la animación
  NProgress.start()

  next()
})

router.afterEach((to, from) => {
  // Completa la animación
  NProgress.done()
})

router.beforeEach((to, from, next) => {
  function validarPermisos (ruta) {
    // Recupera el token
    const jwt = localStorage.getItem('jwt')
    // Decodifica el token
    const jwtDecoded = VueJwtDecode.decode(jwt)

    // Obtiene los roles del usuario
    var rolesUsuario = jwtDecoded.roles

    // Dependiendo el grupo de cada ruta, controla que el usuario tenga el rol asociado a la misma
    switch (ruta.meta.grupo) {
      case constantes.gruposRutas.ADMIN:
        if (rolesUsuario.includes(constantes.roles.ADMIN)) { return true } else { return false }
      case constantes.gruposRutas.USUARIO:
        if (rolesUsuario.includes(constantes.roles.USUARIO)) { return true } else { return false }
      case constantes.gruposRutas.PUBLICAS:
        return true
      default:
        return false
    }
  }

  // Define si es requerida la autenticacion para ir a la ruta "to"
  const requierePermisos = (to.meta.grupo !== constantes.gruposRutas.PUBLICAS)

  // Si es requerida la autenticacion revisa si esta autenticado, y luego si tiene token vencido
  if (requierePermisos) {
    if (!apiService.isAuthenticated()) {
      return next({ name: 'login', query: { redirect: to.path } })
    } else if (apiService.isTokenExpired()) {
      return next({ name: 'sesion-expirada' })
    } else if (!validarPermisos(to)) {
      return next({ name: 'inicio' })
    }
  }

  // Sino continua
  next()
})

export default router
